export enum DroppableId {
    Excluded = 'excluded',
    Included = 'included',
    Available = 'available',
    Selected = 'selected',
}
